// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { GET_APPOINTMENTS } from '../../../../../common/constant'
import { get } from '../../../../../common/api'

export const actionGetAppointments = createAsyncThunk('appointmentsStore/actionGetAppointments', async (params, thunkAPI) => {
    return await get(GET_APPOINTMENTS, params, thunkAPI)
})


export const appointmentsSlice = createSlice({
    name: 'appointmentsStore',

    initialState: {
        //get policy
        loadingGetAppointments: false,
        getAppointments: null
    },
    reducers: {
        //reset or delete public store data
        resetGetAppointmentsResponse: (state) => {
            state.getAppointments = null
        }
    },
    extraReducers: builder => {
        builder
            .addCase(actionGetAppointments.pending, (state) => {
                state.loadingGetAppointments = false
            })
            .addCase(actionGetAppointments.fulfilled, (state, action) => {
                state.loadingGetAppointments = true
                state.getAppointments = action.payload
            })
            .addCase(actionGetAppointments.rejected, (state) => {
                state.loadingGetAppointments = false
            })
    }
})
export const { resetGetAppointmentsResponse } = appointmentsSlice.actions

export default appointmentsSlice.reducer